<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getSuratJalanSupplyForSubcontracts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-surat-jalan-no" label-cols-sm="4" label-cols-lg="3" label="No Surat Jalan" label-for="filter-surat-jalan-no" size="sm" :model.sync="filter.suratJalanNo" />
					<app-input-combobox-autocomplete :options="workOrderSupplySubContracts" optionsLabel="materialIssueNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Material Issue Number (W/O No)" id="filter-" size="sm" :model.sync="filter.workOrderSupplySubcontractId" @input="getWorkOrderSupplySubContracts" @focus="getWorkOrderSupplySubContracts" />
					<app-input-datepicker-range  id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom" :modelTo.sync="filter.deliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Purchase Order" id="filter-" size="sm" :model.sync="filter.purchaseOrderId" @input="getPurchaseOrders" @focus="getPurchaseOrders" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm" :model.sync="filter.vendorId" @input="getVendors" @focus="getVendors" />
					<app-input-textbox id="fieldset-driver-name" label-cols-sm="4" label-cols-lg="3" label="Driver Name" label-for="filter-driver-name" size="sm" :model.sync="filter.driverName" />
					<app-input-textbox id="fieldset-vehicle-number" label-cols-sm="4" label-cols-lg="3" label="Vehicle Number" label-for="filter-vehicle-number" size="sm" :model.sync="filter.vehicleNumber" />
					<app-input-textbox id="fieldset-pic-surat-jalan" label-cols-sm="4" label-cols-lg="3" label="Pic Surat Jalan" label-for="filter-pic-surat-jalan" size="sm" :model.sync="filter.picSuratJalan" />
					<app-input-textbox id="fieldset-admin-surat-jalan" label-cols-sm="4" label-cols-lg="3" label="Admin Surat Jalan" label-for="filter-admin-surat-jalan" size="sm" :model.sync="filter.adminSuratJalan" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getSuratJalanSupplyForSubcontracts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Surat Jalan Supply For Subcontract</span>
				</b-col>
				<b-col>
					<span class="float-right">
<!--						<b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">-->
<!--							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/suratjalansupplyforsubcontract/SuratJalanSupplyForSubcontract.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>-->
<!--							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>-->
<!--							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>-->
<!--						</b-dropdown>-->
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
<!--					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>-->
<!--					-->
<!--					<b-overlay v-if="isShowDeleteButton"-->
<!--							   :show="isDeleteBusy"-->
<!--							   rounded-->
<!--							   opacity="0.6"-->
<!--							   spinner-small-->
<!--							   spinner-variant="primary"-->
<!--							   class="d-inline-block">-->
<!--						<click-confirm>-->
<!--							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>-->
<!--						</click-confirm>-->
<!--					</b-overlay>-->
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-suratjalansupplyforsubcontract" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="suratJalanSupplyForSubcontracts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="suratJalanSupplyForSubcontracts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="No Surat Jalan" class="table-filter">
					<b-form-input id="input-surat-jalan-no-table" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.suratJalanNo" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Material Issue Number (W/O No)" class="table-filter">
					<v-select append-to-body label="materialIssueNumber" :options="workOrderSupplySubContracts" :value="filter.workOrderSupplySubcontractId" :reduce="item => item.id" v-model="filter.workOrderSupplySubcontractId" :filterable="true" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" @search="getWorkOrderSupplySubContracts"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-from-table" reset-button @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.deliveryDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-to-table" reset-button @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.deliveryDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Is Already Delivered" class="table-filter">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isAlreadyDelivered" :reduce="item => item.id" v-model="filter.isAlreadyDelivered" :filterable="true" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Purchase Order" class="table-filter">
					<v-select append-to-body label="purchaseOrderNumber" :options="purchaseOrders" :value="filter.purchaseOrderId" :reduce="item => item.id" v-model="filter.purchaseOrderId" :filterable="true" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" @search="getPurchaseOrders"></v-select>
				</b-th>
				<b-th stacked-heading="Vendor" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorId" :reduce="item => item.id" v-model="filter.vendorId" :filterable="true" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" @search="getVendors"></v-select>
				</b-th>
				<b-th stacked-heading="Driver Name" class="table-filter">
					<b-form-input id="input-driver-name-table" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.driverName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Vehicle Number" class="table-filter">
					<b-form-input id="input-vehicle-number-table" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.vehicleNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Pic Surat Jalan" class="table-filter">
					<b-form-input id="input-pic-surat-jalan-table" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.picSuratJalan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Admin Surat Jalan" class="table-filter">
					<b-form-input id="input-admin-surat-jalan-table" @input="getSuratJalanSupplyForSubcontractsWithoutLoading" v-model="filter.adminSuratJalan" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(suratjalanno)="row">

                <a @click="() => ( $router.push({ name: 'suratjalansupplyforsubcontractdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.suratJalanNo != null && row.item.suratJalanNo != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.suratJalanNo.slice(0, 30) + (row.item.suratJalanNo.length > 30 ? "..." : "" ) : row.item.suratJalanNo : "" }}
						</a>
            
					</template>

			<template v-slot:cell(workOrderSupplySubcontract)="row">
				{{ row.item.workOrderSupplySubcontract != null ? row.item.workOrderSupplySubcontract.materialIssueNumber : "" }}
			</template>
			<template v-slot:cell(deliveryDate)="row">
				{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(purchaseOrder)="row">
				{{ row.item.purchaseOrder != null ? row.item.purchaseOrder.purchaseOrderNumber : "" }}
			</template>
			<template v-slot:cell(vendor)="row">
				{{ row.item.vendor != null ? row.item.vendor.code : "" }}
			</template>
					<template v-slot:cell(front-action)="row">
<!--						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton">-->
<!--							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>-->
<!--						</div>-->
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="purchaseOrderNumber" label-cols-sm="12" :model="row.item.purchaseOrderId" label="Purchase Order" :selected="row.item.purchaseOrder != null ? row.item.purchaseOrder.purchaseOrderNumber : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorId" label="Vendor" :selected="row.item.vendor != null ? row.item.vendor.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-driver-name" label-cols-lg="12"  label="Driver Name" label-for="input-driver-name" size="sm" :model.sync="row.item.driverName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-vehicle-number" label-cols-lg="12"  label="Vehicle Number" label-for="input-vehicle-number" size="sm" :model.sync="row.item.vehicleNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-pic-surat-jalan" label-cols-lg="12"  label="Pic Surat jalan" label-for="input-pic-surat-jalan" size="sm" :model.sync="row.item.picSuratJalan"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-admin-surat-jalan" label-cols-lg="12"  label="Admin Surat jalan" label-for="input-admin-surat-jalan" size="sm" :model.sync="row.item.adminSuratJalan"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(suratJalanSupplyForSubcontractsPaging != null ? suratJalanSupplyForSubcontractsPaging.dataCount : 0)"
									:per-page="(suratJalanSupplyForSubcontractsPaging != null ? suratJalanSupplyForSubcontractsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
<!--        <Upload :openPopup="showPopupUpload"-->
<!--            @resetMethod="resetModalUpload"-->
<!--            @uploadButtonMethod="uploadData" />-->
<!--        <PopupDownload :openPopup="showPopupDownload"-->
<!--            :processId="processId"-->
<!--            @resetModalMethod="resetModal"-->
<!--            label="Popup Download"-->
<!--            :contentLabel="popupDownloadLabel" />-->
<!--        <PopupPDF :openPopup="isShowPopupPDF"-->
<!--            :pdfUrl="pdfUrl"-->
<!--            @resetModalMethod="resetModal"-->
<!--            label="Popup PDF" />-->
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-suratjalansupplyforsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-suratjalansupplyforsubcontact.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-suratjalansupplyforsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import SuratJalanSupplyForSubcontract from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontract';
import SuratJalanSupplyForSubcontractList from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractList';
import SuratJalanSupplyForSubcontractFilter from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		SuratJalanSupplyForSubcontract, 
		SuratJalanSupplyForSubcontractList, 
		SuratJalanSupplyForSubcontractFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"suratJalanNo": {}, "class" : "th-surat-jalan-no first-child", "label" : "No Surat Jalan", key: 'suratJalanNo', sortable: true}, 
				{"workOrderSupplySubcontract": {}, "class" : "th-work-order-supply-subcontract", "label" : "Material Issue Number (W/O No)", key: 'workOrderSupplySubcontract', sortable: true}, 
				{"deliveryDate": {}, "class" : "th-delivery-date last-child", "label" : "Delivery Date", key: 'deliveryDate', sortable: true}, 
				{"isAlreadyDelivered": {}, "class" : "th-is-already-delivered d-stack-none", "label" : "Is Already Delivered", key: 'isAlreadyDelivered', sortable: true}, 
				{"purchaseOrder": {}, "class" : "th-purchase-order d-stack-none", "label" : "Purchase Order", key: 'purchaseOrder', sortable: true}, 
				{"vendor": {}, "class" : "th-vendor d-stack-none", "label" : "Vendor", key: 'vendor', sortable: true}, 
				{"driverName": {}, "class" : "th-driver-name d-stack-none", "label" : "Driver Name", key: 'driverName', sortable: true}, 
				{"vehicleNumber": {}, "class" : "th-vehicle-number d-stack-none", "label" : "Vehicle Number", key: 'vehicleNumber', sortable: true},
				{"picSuratJalan": {}, "class" : "th-pic-surat-jalan d-stack-none", "label" : "Pic Surat Jalan", key: 'picSuratJalan', sortable: true},
				{"adminSuratJalan": {}, "class" : "th-admin-surat-jalan d-stack-none", "label" : "Admin Surat Jalan", key: 'adminSuratJalan', sortable: true},
				// {"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			suratJalanSupplyForSubcontracts: [],
			suratJalanSupplyForSubcontractsPaging: {},
			workOrderSupplySubContracts : [],
			purchaseOrders : [],
			vendors : [],
			suratJalanSupplyForSubcontractDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	methods : {
		getSuratJalanSupplyForSubcontracts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SuratJalanSupplyForSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.suratJalanSupplyForSubcontracts = result.data
					this.suratJalanSupplyForSubcontractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getSuratJalanSupplyForSubcontractsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SuratJalanSupplyForSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.suratJalanSupplyForSubcontracts = result.data
					this.suratJalanSupplyForSubcontractsPaging = result
				}
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			await WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
			})
			.catch(error => {});
		},
		getPurchaseOrders : async function(input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			await PurchaseOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new SuratJalanSupplyForSubcontractFilter();
			this.getSuratJalanSupplyForSubcontracts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getSuratJalanSupplyForSubcontracts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				SuratJalanSupplyForSubcontract.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			SuratJalanSupplyForSubcontract.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			SuratJalanSupplyForSubcontract.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			SuratJalanSupplyForSubcontract.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'suratjalansupplyforsubcontractedit';
						if(this.isScannerMode) {
							createRoute = 'suratjalansupplyforsubcontractscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			SuratJalanSupplyForSubcontract.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'suratjalansupplyforsubcontractedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			SuratJalanSupplyForSubcontract.deleteData(this, id).then(result => {
				if (result)
				{
					this.getSuratJalanSupplyForSubcontracts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				SuratJalanSupplyForSubcontract.deleteMultipleData(this).then(result => {
					this.getSuratJalanSupplyForSubcontracts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableSuratJalanSupplyForSubcontractParent = document.getElementById('table-list-suratjalansupplyforsubcontract').parentNode;
			tableSuratJalanSupplyForSubcontractParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableSuratJalanSupplyForSubcontractParent.scrollWidth - tableSuratJalanSupplyForSubcontractParent.offsetWidth) == Math.ceil(tableSuratJalanSupplyForSubcontractParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableSuratJalanSupplyForSubcontractParent = document.getElementById('table-list-suratjalansupplyforsubcontract').parentNode;
			tableSuratJalanSupplyForSubcontractParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableSuratJalanSupplyForSubcontractParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new SuratJalanSupplyForSubcontractFilter();
		this.getWorkOrderSupplySubContracts()
		this.getPurchaseOrders()
		this.getVendors()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Surat Jalan Supply For Subcontract"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getSuratJalanSupplyForSubcontracts();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getSuratJalanSupplyForSubcontracts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getSuratJalanSupplyForSubcontracts();
			}
		},
		currentPage: {
			handler: function() {
				this.getSuratJalanSupplyForSubcontracts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getSuratJalanSupplyForSubcontracts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				SuratJalanSupplyForSubcontract.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "suratjalansupplyforsubcontractindex") {
					this.getSuratJalanSupplyForSubcontractsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "surat_jalan_supply_for_subcontract").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
